const GENERIC_MINI_RENDERER_EXTENSIONS = new Set(["md", "txt", "html", "json", "docx", "pdf"])
const EXCEL_MINI_RENDERER_EXTENSIONS = new Set(["xlsx", "xls"])

/** File types whose previews are expensive (full-fidelity render / large parse). */
export const HEAVY_PREVIEW_EXTENSIONS = new Set(["docx", "xlsx", "xls"])

/**
 * Fallback when `/api/config` has not loaded yet or omits `documentPreviewSlowMs`.
 * Server: `DOCUMENT_PREVIEW_SLOW_MS` (legacy: `HEAVY_PREVIEW_SLOW_THRESHOLD_MS`), default 4000.
 */
export const DEFAULT_DOCUMENT_PREVIEW_SLOW_MS = 4000

export type HoverMiniPreviewMode = "none" | "generic" | "excel"

const MINI_PREVIEW_DEBOUNCE_MS = 700

function isStandaloneDocumentPath(decodedUrl: string): boolean {
  return /\/content\/doc\/[^/?#]+/i.test(decodedUrl)
}

export function getHoverMiniRendererExtension(documentUrl: string): string {
  if (!documentUrl) {
    return ""
  }

  const decodedUrl = decodeURIComponent(documentUrl)
  if (isStandaloneDocumentPath(decodedUrl)) {
    return "md"
  }

  const noFragment = decodedUrl.split("#")[0] ?? decodedUrl
  const noQuery = noFragment.split("?")[0] ?? noFragment
  const extension = noQuery.split(".").pop()?.toLowerCase() ?? ""
  return extension
}

export function getHoverMiniPreviewMode(documentUrl: string): HoverMiniPreviewMode {
  const extension = getHoverMiniRendererExtension(documentUrl)
  if (GENERIC_MINI_RENDERER_EXTENSIONS.has(extension)) {
    return "generic"
  }
  if (EXCEL_MINI_RENDERER_EXTENSIONS.has(extension)) {
    return "excel"
  }
  return "none"
}

export function canUseHoverMiniRenderer(documentUrl: string): boolean {
  return getHoverMiniPreviewMode(documentUrl) !== "none"
}

export function isHeavyPreviewExtension(documentUrl: string): boolean {
  const ext = getHoverMiniRendererExtension(documentUrl)
  return HEAVY_PREVIEW_EXTENSIONS.has(ext)
}

export function getHoverMiniRendererDelayMs(): number {
  return MINI_PREVIEW_DEBOUNCE_MS
}
